import { Box, Typography, Chip, Button } from "@mui/material";
import { useState, useEffect } from "react";

const GITHUB_USERNAME = "muriminicholas";
const REPO_NAME = ""; // <-- fix repo name


function useLatestCommit() {
  const [lastUpdate, setLastUpdate] = useState("");

  useEffect(() => {
    fetch(
      `https://api.github.com/repos/${GITHUB_USERNAME}/${REPO_NAME}/commits?per_page=1`
    )
      .then((res) => res.json())
      .then((data) => {
        if (data && data[0]) {
          const date = new Date(data[0].commit.committer.date);
          setLastUpdate(
            date.toLocaleDateString() +
              " " +
              date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
          );
        }
      })
      .catch((err) => console.error("Error fetching commit:", err));
  }, []);

  return lastUpdate;
}

export default function CurrentlyBuilding() {
  const lastCommitTime = useLatestCommit();

  return (
    <Box
      sx={{
        p: 3,
        borderRadius: 3,
        background: "rgba(255,255,255,0.03)",
        border: "1px solid rgba(255,255,255,0.08)",
        backdropFilter: "blur(10px)",
        width: "90%",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h1" sx={{ opacity: 0.7, color: "text.heading"}}>
          Currently Building
        </Typography>

        {lastCommitTime && (
          <Typography variant="caption" sx={{ opacity: 0.5 }}>
            Updated: {lastCommitTime}
          </Typography>
        )}
      </Box>

      {/* Title */}
      <Typography variant="h5" sx={{ fontWeight: 600, mt: 1 ,color: "text.subheading"}}>
        Atomic Furnishers
      </Typography>

      {/* Description */}
      <Typography sx={{ opacity: 0.7, mt: 1 }}>
        Online furnishing & interior platform with secure Node.js backend,
        Google Auth, and MySQL. Focused on scalability and data protection.
      </Typography>

      {/* Tech Stack */}
      <Box sx={{ mt: 2, display: "flex", gap: 1, flexWrap: "wrap" }}>
        <Chip label="Node.js" size="small" />
        <Chip label="Next.js" size="small" />
        <Chip label="TypeScript" size="small" />
      </Box>

      {/* Status */}
      <Chip
        label="In Progress"
        size="small"
        sx={{
          mt: 2,
          background: "rgba(0,255,150,0.1)",
          color: "#00ffa6",
          border: "1px solid rgba(0,255,150,0.3)",
        }}
      />

      {/* Actions */}
      <Box
        sx={{
          mt: 3,
          display: "flex",
          gap: 2,
          flexWrap: "wrap",
        }}
      >
        <Button
          variant="contained"
          size="small"
          href="https://github.com/muriminicholas/atomic-furnishers"
          target="_blank"
        >
          GitHub
        </Button>

        <Button
          variant="outlined"
          size="small"
          href="https://atomic-furnishers-1.vercel.app/"
          target="_blank"
        >
          Live Demo
        </Button>

        <Button
          size="small"
          sx={{
            color: "#00ffa6",
            border: "1px dashed rgba(0,255,150,0.4)",
          }}
          onClick={() => console.log("Open snippet preview")}
        >
          Snippet
        </Button>
      </Box>

      {/* Progress */}
      <Box sx={{ mt: 3 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mb: 0.5,
          }}
        >
          <Typography variant="caption" sx={{ opacity: 0.5 }}>
            Development Progress
          </Typography>
          <Typography variant="caption" sx={{ opacity: 0.5 }}>
            75%
          </Typography>
        </Box>

        <Box
          sx={{
            height: 4,
            width: "100%",
            background: "rgba(255,255,255,0.1)",
            borderRadius: 2,
          }}
        >
          <Box
            sx={{
              height: "100%",
              width: "75%",
              background: "#00ffa6",
              borderRadius: 2,
              boxShadow: "0 0 10px rgba(0,255,166,0.5)",
            }}
          />
        </Box>
      </Box>
    </Box>
  );
}
